import { I18n } from "i18n-js";
import { config } from "../constants/config";

const i18n = new I18n();

i18n.defaultLocale = config.DEFAULT_LOCALE;
i18n.enableFallback = true;

export { i18n };
